// extracted by mini-css-extract-plugin
module.exports = {"row":"Kalendar_row__1PAuz","col":"Kalendar_col__2JcjI","card":"Kalendar_card__34ZDw","title":"Kalendar_title__3mp4g","test":"Kalendar_test__3X79f"};